<div class="fixed-bg"></div>
<div class="result-page">
  <div class="container">
    <div class="icon-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    </div>

    <h1>Pagamento Annullato</h1>

    <p class="main-message">
      Il pagamento dell'acconto per l'iscrizione a
      <strong>Ohel Camp 2026</strong> non è stato completato.
    </p>

    <p class="sub-message">
      Non ti è stato addebitato alcun importo. Puoi riprovare in qualsiasi
      momento compilando nuovamente il modulo di iscrizione.
    </p>

    <div class="info-box">
      <h3>Cosa puoi fare</h3>
      <ul>
        <li>Tornare al modulo di iscrizione e riprovare</li>
        <li>Verificare i dati della carta di pagamento</li>
        <li>Contattarci se hai bisogno di assistenza</li>
      </ul>
    </div>

    <div class="actions">
      <a routerLink="/ohelcamp" class="primary-btn">Riprova l'iscrizione</a>
      <a routerLink="/" class="secondary-btn">Torna alla Home</a>
    </div>
  </div>
</div>
